import type { RouteRecordRaw } from 'vue-router'
const DefaultLayout = () => import('@/layouts/DefaultLayout.vue')

export const conektaRoutes: RouteRecordRaw[] = [
  {
    path: '/conekta',
    component: DefaultLayout,
    meta: {
      requireAuth: true,
      module: 'conektaTools'
    },
    children: [
      {
        path: '',
        redirect: { name: 'conekta.transactions' }
      },
      {
        path: '',
        component: () =>
          import('@/views/toolsOperations/toolOperationsHomeView.vue'),
        children: [
          {
            path: 'transactions',
            name: 'conekta.transactions',
            component: () =>
                import('@/modules/operationsTools/conekta/ui/view/conektaList.vue'),                
            meta: {
              permission: 'CONEKTA_TRANSACTIONS'
            }
          }
        ]
      }
    ]
  }
]
